<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1 v-if="form.id">{{ $t('common.change')}} {{zone.code}}</h1>
      <h1 v-else>{{ $t('zones.new_zone')}}</h1>
    </div>
    <div class="details-component__content">
      <form class="form fixed-form">

        <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-150">

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('code') || codeExists }">
            <td class="details-table__col details-table__col_label">
              <label for="code" class="form__label">{{ $t('zones.code')}}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.code" id="code"
                v-validate data-vv-rules="required|max:255" name="code"/>
              <tooltip v-show="errors.has('code:required')" class="form__validation">{{ $t('errors.field_required') }}</tooltip>
              <tooltip v-show="errors.has('code:min')" class="form__validation">{{ $t('errors.field_min') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('address')}">
            <td class="details-table__col details-table__col_label">
              <label for="address" class="form__label">{{ $t('common.address')}}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.address" id="address" v-validate data-vv-rules="required|min:3|max:255" data-vv-as="Aadress" name="address"/>
              <tooltip v-show="errors.has('address:required')" class="form__validation">{{ $t('errors.field_required') }}</tooltip>
              <tooltip v-show="errors.has('address:min')" class="form__validation">{{ $t('errors.field_min') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('epsZoneId') || epsZoneIdExists}">
            <td class="details-table__col details-table__col_label">
              <label for="epsZoneId" class="form__label">{{ $t('zones.eps_zone_id')}}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.epsZoneId" id="epsZoneId" v-validate data-vv-rules="required|numeric" data-vv-as="epsZoneId" name="epsZoneId" />
              <tooltip v-show="errors.has('epsZoneId:required')" class="form__validation">{{ $t('errors.field_required') }}</tooltip>
              <tooltip v-show="errors.has('epsZoneId:numeric')" class="form__validation">{{ $t('errors.field_numeric') }}</tooltip>
            </td>
          </tr>

          <!--  Zone parking spaces amount  -->

          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label for="epsZoneId" class="form__label">{{ $t('zones.parking_spaces')}}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input"
                     v-model.trim="form.parking_spaces"
                     id="parking_spaces"
                     data-vv-as="parking_spaces"
                     name="parking_spaces"
              />
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('zoom')}">
            <td class="details-table__col details-table__col_label">
              <label for="zoom" class="form__label">{{ $t('maps.zoom') }}</label>
            </td>
            <td class="details-table__col">
              <el-input-number id="zoom" v-model="form.zoom" :min="1" :max="20" @change="zoomChange"></el-input-number>
            </td>
          </tr>
          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('longitude')}">
            <td class="details-table__col details-table__col_label">
              <label for="longitude" class="form__label">{{ $t('maps.longitude') }}</label>
            </td>
            <td class="details-table__col">
              <input type="number" class="form__input"
                     name="longitude"
                     id="longitude"
                     v-model="form.center[0]"
              />
            </td>
          </tr>
          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('latitude')}">
            <td class="details-table__col details-table__col_label">
              <label for="latitude" class="form__label">{{ $t('maps.latitude') }}</label>
            </td>
            <td class="details-table__col">
              <input type="number" class="form__input"
                     name="latitude"
                     id="latitude"
                     v-model="form.center[1]"
              />
            </td>
          </tr>
          <tr class="details-table__row">
            <td class="details-table__map-container" colspan="2">
              <div id='zone-edit-map-dom'></div>
            </td>
          </tr>
          <!-- tr class="details-table__row" :class="{'details-table__row_error' : errors.has('coordinates')}">
            <td class="details-table__col details-table__col_label">
              <label for="coordinates" class="form__label">{{ $t('zones.coordinates')}}</label>
            </td>
            <td class="details-table__col">
              <textarea type="textarea" class="form__input" v-model.trim="form.coordinatesString" id="coordinates" name="coordinates" rows="20"></textarea>
            </td>
          </tr -->

          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label for="comment" class="form__label">{{ $t('parking.comment')}}</label>
            </td>
            <td class="details-table__col"></td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="wrapperwrapper">
                <div class="codewrapper">
                  <codemirror id="comment" name="comment" v-model.trim="form.comment" :options="cmOptions"></codemirror>
                </div>
              </div>
            </td>
          </tr>

          <tr class="details-table__row auto-height" v-if="isAutloIntegrationEnabled()">
            <td class="details-table__col txt-to-left padding-t-4" colspan="3">
              <label class="form__label form__label__long no-hide with_checkbox">
                <input type="checkbox" id="is_autlo_zone" name="is_autlo_zone" class="form__fieldset__checkbox" v-model="form.isAutloZone">
                <span class="form__fieldset__custom-checkbox"></span>
                <span class="custom-checkbox-label">{{$t('zones.autlo_zone')}}</span>
              </label>
            </td>
          </tr>

        </table>

        <!-- AutoPay settings if enabled  -->

          <table
            class="details-table tenant no-col-padding edit-table label-col-wide-150"
            v-if="user.autopayEnabled"
          >
            <tr class="details-table__row">
              <td colspan="2"><h3>{{ $t('autopay.settings')}}</h3></td>
            </tr>
            <tr class="details-table__row" >
              <td class="details-table__col details-table__col_label">
                <label for="client_secret" class="form__label">{{ $t('autopay.client_secret')}}</label>
              </td>
              <td class="details-table__col">
                <input type="text" class="form__input"
                       v-model.trim="form.client_secret"
                       id="client_secret"
                       data-vv-as="client_secret"
                       name="client_secret"
                />
              </td>
            </tr>
            <tr class="details-table__row" >
              <td class="details-table__col details-table__col_label">
                <label for="client_id" class="form__label">{{ $t('autopay.client_id')}}</label>
              </td>
              <td class="details-table__col">
                <input type="text" class="form__input"
                       v-model.trim="form.client_id"
                       id="client_id"
                       data-vv-as="client_id"
                       name="client_id"
                />
              </td>
            </tr>
            <tr class="details-table__row" >
              <td class="details-table__col details-table__col_label">
                <label for="permit_definition" class="form__label">{{ $t('autopay.permit_definition')}}</label>
              </td>
              <td class="details-table__col">
                <input type="text" class="form__input"
                       v-model.trim="form.permit_definition"
                       id="permit_definition"
                       data-vv-as="permit_definition"
                       name="permit_definition"
                />
              </td>
            </tr>
          </table>

        <div class="form__buttons buttonset">
          <router-link v-if="isNew" :to="{ name: 'zones' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <router-link v-else :to="{ name: 'zones', params: { id: $route.params.id} }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" class="buttonset__button btn btn--main" v-on:click.prevent.stop="onSubmit()">
            {{ $t('common.save') }}
          </button>
        </div>

        <WarningModal v-if="zonesError" @close="closeWarningModal()">
          <h1 slot="header">{{ $t('common.error') }}</h1>
          <p slot="body">{{ warningModalBody }}</p>
        </WarningModal>

      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import L from 'leaflet';
import { mapGetters } from 'vuex';
import 'styles/blocks/details.scss';
import * as mTypes from 'store/mutation-types';
import Autocomplete from 'common/Autocomplete';
import Tooltip from 'common/Tooltip';
import WarningModal from 'common/WarningModal';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';

export default {
  components: {
    Autocomplete,
    Tooltip,
    WarningModal,
    codemirror,
  },
  watch: {
    $route: 'fetchAllData',
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
    ...mapGetters({
      zone: 'zones/zone/zone',
      user: 'user/user/user',
      zonesError: 'zones/zone/error',
    }),
  },
  data() {
    return {
      form: {
        center: [0, 0],
        zoom: 10,
        // AutoPay properties
        client_secret: null,
        client_id: null,
        permit_definition: null,
      },
      style: 'klokantech-basic',
      warningModalBody: null,
      epsZoneIdExists: false,
      codeExists: false,
      mapInstance: null,
      drawInstance: null,
      cmOptions: {
        tabSize: 2,
        mode: 'application/json',
        lineNumbers: true,
        line: true,
      },
    };
  },
  mounted() {
    this.fetchAllData();
  },
  created() {
    this.$store.commit(`zones/zone/${mTypes.CLEAR_STATE}`);
  },
  methods: {
    fetchAllData() {
      if (this.$route.params.id) {
        this.fetchZone();
      } else {
        this.$store.commit(`zones/zone/${mTypes.CLEAR_STATE}`);
        this.form = this.zone;
        this.initMap();
        this.initPosition();
      }
    },
    fetchZone() {
      this.$store.dispatch('zones/zone/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
        this.form = Object.assign({
          center: [0, 0],
          zoom: 10,
        }, this.zone);
        if (this.zone.autopay_settings) {
          this.form.client_secret = this.zone.autopay_settings.client_secret;
          this.form.client_id = this.zone.autopay_settings.client_id;
          this.form.permit_definition = this.zone.autopay_settings.permit_definition;
        }
        if (this.form.comment) {
          this.form.comment = JSON.stringify(JSON.parse(this.form.comment), 0, 2);
        }
        this.initMap();
        // if (!this.form.center[0]) {
        //  this.initPosition();
        // }
      });
    },
    zoomChange(level) {
      this.mapInstance.zoomTo(level);
    },
    cleanupCoordinates(coordinates) {
      let data = {};

      if (coordinates) {
        if (coordinates.properties) {
          coordinates.properties = {};
        }

        if (Array.isArray(coordinates) && coordinates[0].type === 'Feature') {
          data = {
            type: 'FeatureCollection',
            features: coordinates,
          };
        } else if (coordinates === Object(coordinates) && coordinates.type === 'Feature') {
          if (coordinates.geometry &&
                  coordinates.geometry.coordinates && coordinates.geometry.coordinates.length < 4) {
            return {
              type: 'FeatureCollection',
              features: [],
            };
          }

          data = {
            type: 'FeatureCollection',
            features: [coordinates],
          };
        } else if (Array.isArray(coordinates) && coordinates[0] && coordinates[0].type === 'FeatureCollection') {
          data = coordinates[0];
        } else if (coordinates === Object(coordinates) && coordinates.type === 'FeatureCollection') {
          data = coordinates;
        }
      }
      return data;
    },
    setCenter() {
      if (this.form.center[0] > 0 && this.form.center[1] > 0) {
        this.mapInstance.setCenter(this.form.center);
        return;
      } else if (this.form.coordinates) {
        const bounds = L.geoJSON(this.form.coordinates).getBounds();
        if (bounds.isValid()) {
          const center = bounds.getCenter();
          if (center) {
            this.mapInstance.setCenter(center);
            return;
          }
        }
      }
      //
      this.mapInstance.setCenter([24.707, 59.412]);
    },
    initMap() {
      Vue.nextTick(() => {
        this.mapInstance = new mapboxgl.Map({
          container: 'zone-edit-map-dom',
          style: `${process.env.MAPS_URL}/styles/${this.style}/style.json`,
          hash: false,
          center: this.form.center,
          zoom: this.form.zoom,
        });
        this.mapInstance.addControl(new mapboxgl.NavigationControl());
        this.mapInstance.on('move', () => {
          const c = this.mapInstance.getCenter();
          const z = this.mapInstance.getZoom();
          this.form.center = [c.lng, c.lat];
          this.form.zoom = z;
        });
        this.setCenter();

        this.drawInstance = new MapboxDraw({
          displayControlsDefault: false,
          controls: { polygon: true, trash: true },
        });
        this.mapInstance.addControl(this.drawInstance, 'top-left');
        try {
          this.drawInstance.set(this.cleanupCoordinates(this.form.coordinates));
        } catch (e) {
          console.log('Draw error', e);
        }
      });
    },
    initPosition() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.form.center = [position.coords.longitude, position.coords.latitude];
        Vue.nextTick(() => {
          this.mapInstance.setCenter(this.form.center);
        });
      });
    },
    onSubmit() {
      this.codeExists = false;
      this.epsZoneIdExists = false;
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            return;
          }
          if (!this.form.isAutloZone) {
            this.form.isAutloZone = false;
          }
          this.form.coordinates = this.drawInstance.getAll();
          // Fix properties as PHP messes it up
          if (Array.isArray(this.form.coordinates.features)) {
            const l = this.form.coordinates.features.length;
            for (let i = 0; i < l; i += 1) {
              this.form.coordinates.features[i].properties.dummy = true;
            }
          }
          this.$store.dispatch('zones/zone/saveZone', { zone: this.form, user: this.user }).then(() => {
            if (!this.zonesError) {
              this.form = {};
              this.$store.commit(`landlord/zones/${mTypes.EDIT_DATA}`, this.zone);
              this.$router.push({ name: 'zone', params: { id: this.zone.id } });
            } else if (this.zonesError.body.epsZoneId) {
              this.zonesError.body.epsZoneId.forEach((el) => {
                if (el === 'The eps zone id has already been taken.') {
                  this.warningModalBody = this.$t('zones.error_eps_zone_id_exicits');
                  this.epsZoneIdExists = true;
                }
              });
            } else if (this.zonesError.body.code) {
              this.zonesError.body.code.forEach((el) => {
                if (el === 'The code has already been taken.') {
                  this.warningModalBody = this.$t('zones.error_code_exicits');
                  this.codeExists = true;
                }
              });
            } else {
              this.warningModalBody = this.$t('zones.save_error');
            }
          }).catch(() => {
          });
          this.$validator.clean();
          this.$store.commit(`zones/zone/${mTypes.DATA_ERROR}`, null);
        }).catch(() => {
        });
    },
    closeWarningModal() {
      this.$store.commit(`zones/zone/${mTypes.DATA_ERROR}`, null);
      this.warningModalBody = null;
    },
  },
};
</script>

<style lang="scss" scoped>

#coordinates {
  text-align: left;
}

#zone-edit-map-dom {
  width: 100%;
  height: 500px;
}

.wrapperwrapper{
  max-width: 100%;
  display: block;
  position: relative;
  height: 500px;
}

.codewrapper {
  width: 100%;
  display: block;
  position: absolute;
  height: 500px;
}

</style>



// WEBPACK FOOTER //
// src/components/zones/AddZoneView.vue